import React, { useState, useEffect } from 'react';
import AddTaskModal from '../Task/AddTaskModule';
import { Link } from 'react-router-dom';
import authStorage from '../../Auth/Storage';
import { useNavigate } from "react-router-dom";

function Header() {
  const [username, setUsername] = useState(null);
  const [visible, setVisible] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  function showModal() {
    setVisible(true);
  }
  
  const history = useNavigate();

  const date = new Date();
  const today = date.toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  function getUsername() {
    const userName = authStorage.getUser();
    if (!userName) return;

    const { username } = JSON.parse(userName);
    setUsername(username);
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    const sidebar = document.getElementById('sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (sidebar) {
      sidebar.classList.toggle('mobile-open');
    }
    if (overlay) {
      overlay.classList.toggle('active');
    }
  };

  const handleLogout = () => {
    authStorage.removeUser();
    history("/login");
    window.location.reload();
  };

  useEffect(() => {
    getUsername();
  }, []);

  return (
    <>
      {/* Mobile Sidebar Toggle */}
      <button 
        className="sidebar-toggle d-lg-none"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        <i className="bi bi-list fs-5"></i>
      </button>

      {/* Sidebar Overlay for Mobile */}
      <div 
        className="sidebar-overlay"
        onClick={toggleSidebar}
      ></div>

      <div id="header" className="py-3 w-100">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-12 col-lg-8 mb-3 mb-lg-0">
              <div className="d-flex align-items-center">
                <div>
                  <h2 className="mb-1 fw-bold gradient-text">
                    Dashboard Overview
                  </h2>
                  <p className="text-muted mb-0 small">
                    <i className="bi bi-calendar3 me-2"></i>
                    {today}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="d-flex justify-content-lg-end justify-content-between align-items-center gap-3">
                
                {/* Notifications */}
                <div className="dropdown">
                  <button
                    className="btn btn-link p-0 position-relative"
                    id="notificationDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ border: 'none', background: 'none' }}
                  >
                    <i className="bi bi-bell fs-4 text-primary"></i>
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill notification-badge">
                      0
                    </span>
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end shadow-modern animate-slide-in"
                    aria-labelledby="notificationDropdown"
                    style={{ minWidth: "320px", maxWidth: "400px" }}
                  >
                    <li className="px-3 py-2 border-bottom">
                      <h6 className="mb-0 fw-bold">
                        <i className="bi bi-bell me-2"></i>
                        Notifications
                      </h6>
                    </li>
                    <li className="px-3 py-3 text-center text-muted">
                      <i className="bi bi-bell-slash fs-1 text-muted"></i>
                      <p className="mb-0 mt-2">No new notifications</p>
                    </li>
                    <li className="border-top">
                      <a className="dropdown-item text-center py-2 fw-medium text-primary" href="#">
                        <i className="bi bi-arrow-right me-1"></i>
                        View all notifications
                      </a>
                    </li>
                  </ul>
                </div>

                {/* User Profile Dropdown */}
                <div className="dropdown">
                  <button
                    className="btn btn-link d-flex align-items-center p-0 text-decoration-none"
                    id="userDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ border: 'none', background: 'none' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2" style={{width: '40px', height: '40px'}}>
                        <i className="bi bi-person-fill text-primary"></i>
                      </div>
                      <div className="d-none d-md-block text-start">
                        <div className="fw-semibold text-dark small">
                          {username || "User"}
                        </div>
                        <div className="text-muted" style={{fontSize: '12px'}}>
                          Administrator
                        </div>
                      </div>
                      <i className="bi bi-chevron-down ms-2 text-muted"></i>
                    </div>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end user-dropdown animate-slide-in" aria-labelledby="userDropdown">
                    <li className="px-3 py-2 border-bottom">
                      <div className="d-flex align-items-center">
                        <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '32px', height: '32px'}}>
                          <i className="bi bi-person-fill text-primary"></i>
                        </div>
                        <div>
                          <div className="fw-semibold">{username || "User"}</div>
                          <small className="text-muted">Administrator</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <i className="bi bi-person me-2"></i>
                        My Profile
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <i className="bi bi-gear me-2"></i>
                        Settings
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <i className="bi bi-question-circle me-2"></i>
                        Help & Support
                      </a>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <button 
                        className="dropdown-item text-danger" 
                        onClick={handleLogout}
                        style={{ border: 'none', background: 'none', width: '100%', textAlign: 'left' }}
                      >
                        <i className="bi bi-box-arrow-right me-2"></i>
                        Sign Out
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {visible && <AddTaskModal setVisible={setVisible} />}
      </div>
    </>
  );
}

export default Header;